exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stick-below-nav[data-v-0b912530] {\n  position: sticky !important;\n  top: 78px !important;\n}\n.slide-enter-active[data-v-0b912530] {\n  transition-duration: 0.5s;\n  transition-timing-function: ease-in-out;\n}\n.slide-leave-active[data-v-0b912530] {\n  transition-duration: 0.5s;\n  transition-timing-function: ease-in-out;\n}\n.slide-enter-to[data-v-0b912530], .slide-leave[data-v-0b912530] {\n  max-height: 400px;\n  overflow: hidden;\n}\n.slide-enter[data-v-0b912530], .slide-leave-to[data-v-0b912530] {\n  overflow: hidden;\n  max-height: 0;\n}\n", ""]);

// exports
